/* eslint-disable no-undef */
import * as React from "react";
import { makeStyles, mergeClasses, shorthands, tokens } from "@fluentui/react-components";
import  {DocumentIcon, GPTIcon } from ".."
import { inject, observer } from "mobx-react";
import { modelNames, views } from "./types";
import { reportError } from "./utilities";
import Store from "./store";

const useStyles = makeStyles({
  intro: { display: "grid", alignItems: "center", ...shorthands.padding("0.5rem") },
  infoText: { fontWeight: "500", fontSize: "1.2em", marginBottom: "1.2em", textAlign: "center" },
  card: {
    ...shorthands.padding("0.8rem"),
    marginTop: "0.1rem",
    marginBottom: "0.5rem",
    maxHeight: "70px",
    ...shorthands.borderRadius("1rem"),
    cursor: "pointer",
    wordWrap: "break-word",
    boxShadow: tokens.shadow4,
    ...shorthands.borderStyle("solid"),
    ...shorthands.borderWidth("1px"),
    textAlign: "center",
  },
  cardHeader: { display: "flex", alignItems: "center", ...shorthands.gap("0.2rem"), justifyContent: "center" },
  standard: { color: "#D04A02" },
  document: { color: "#295477" },
  standardBorder: { ...shorthands.borderColor("#D04A02") },
  documentBorder: { ...shorthands.borderColor("#295477") },
});


const IntroCard = inject("store")(
  observer(({ store }: {store: Store}) => {
    const classes = useStyles();

    function handleCardClick(model: modelNames) {
      store.setModel(model);
      store.setView(views.chat);
      const introElement = document.getElementById("Intro");
      introElement.style.display = "none";
      Office.context.document.settings.set("hideIntro", true);
      Office.context.document.settings.saveAsync(function (asyncResult) {
        if (asyncResult.error) {
          reportError(new Error(`Saving Introcard failed: ${asyncResult.error}`), store.getToken())
        } 
        else {
          store.setHideIntro(true)
        }
      });
    }

    return (
      <div className={classes.intro} id="Intro">
        <h2 className={classes.infoText}>Use Chatbot TLS in two modes:</h2>
        <div className={mergeClasses(classes.card, classes.documentBorder)} onClick={() => handleCardClick(modelNames.documentModelName)}>
          <div className={mergeClasses(classes.cardHeader, classes.document)}>
            <DocumentIcon />
            <b>{"GPT-Document"}</b>
          </div>
          <p>
            {
              "Chat with client work material, court cases and tax administration guidances"
            }
          </p>
        </div>

        <div className={mergeClasses(classes.card, classes.standardBorder)} onClick={() => handleCardClick(modelNames.baseModelName)}>
          <div className={mergeClasses(classes.cardHeader, classes.standard)}>
            <GPTIcon />
            <b>{"GPT-Standard"}</b>
          </div>
          <p>
            {
              "Chat with GPT only"
            }
          </p>
        </div>
      </div>
    );
  })
);

export default IntroCard;
